















import Vue from 'vue'
import { mapState } from 'vuex'
import { State, Action, Getter } from 'vuex-class'
import Component from 'vue-class-component'
import GetIdentifyData from '@/utils/identifyFields/countries'
import { CountryItem } from '@/utils/identifyFields/countries/countryTypes'
import { ProviderType } from '@/utils/identifyFields/providers/providerTypes'
import IdentifyInputsRenderer from '@/components/IdentifyWizard/IdentifyInputsRenderer.vue'
import IdentifyWaitingForProvider from '@/components/IdentifyWizard/IdentifyWaitingForProvider.vue'
import IdentifyRedirectContent from '@/components/IdentifyWizard/IdentifyRedirectContent.vue'
import ProviderSelector from '@/components/ProviderSelector.vue'
import { ContextState, User, Config } from '@/store/context/contextTypes'
import JavascriptAPI from '@/utils/JavascriptAPI'
import BankIdLogo from '@/assets/icons/bankId.svg'

// Vuex + typescript setup guide: https://codeburst.io/vuex-and-typescript-3427ba78cfa8

// define used modules
const _CONTEXT_: string = 'context'

@Component({
  props: {
    handleInputValue: { type: Function, required: true }
  },
  computed: {
    ...mapState({
      userWizardData: (state: any): User => state.context.userWizardData,
      identifyWizardStep: (state: any): User => state.context.identifyWizardStep,
      config: (state: any): object => state.context.config,
      isLoading: (state: any): boolean => state.context.isLoading,
      waitingForIdentifyProvider: (state: any): boolean => state.context.waitingForIdentifyProvider,
      identifyProvider: (state: any): boolean => state.context.config.identifyProvider,
      wizardIdentifyProvider: (state: any): boolean => state.context.wizardIdentifyProvider
    })
  },
  components: {
    ProviderSelector,
    IdentifyInputsRenderer,
    IdentifyWaitingForProvider,
    IdentifyRedirectContent
  }
})
export default class IdentityWizard extends Vue {
  config: Config
  identifyWizardStep: number
  wizardIdentifyProvider: ProviderType
  isLoading: Boolean
  waitingForIdentifyProvider: Boolean
  @State('context') context: ContextState
  @Action('setEditUser', { namespace: _CONTEXT_ }) setEditUser: any
  @Action('setIdentifyProvider', { namespace: _CONTEXT_ }) setIdentifyProvider: any
  @Action('setIdentifyProviderId', { namespace: _CONTEXT_ }) setIdentifyProviderId: any

  beforeMount () {
    // We assign this to local state since we don't need to filter+sort all available fields based on config more than once¨
    const selectedProvider = this.getSelectedProvider()
    this.setIdentifyProvider(selectedProvider)
    if (selectedProvider.id === 'manual') {
      this.setEditUser(true)
    }
  }

  async mounted () {
    setTimeout(() => {
      JavascriptAPI.__REPORT_CLIENT_HEIGHT__()
      setTimeout(() => {
        JavascriptAPI.__REPORT_CLIENT_HEIGHT__()
      }, 200)
    }, 50)
  }

  get identifyContent (): any {
    const { country, identifyFields } = this.config
    return GetIdentifyData[country](identifyFields)
  }

  // methods
  getSelectedProvider (): ProviderType {
    const { identifyProvider } = this.config
    const provider: ProviderType = this.identifyContent.providers.find((provider: ProviderType) => (provider.id === identifyProvider))
    if (!provider) {
      console.error('No provider found matching: ', identifyProvider + ' in the selected country. Fallback to first provider')
      const firstProvider = this.identifyContent.providers[0]
      this.setIdentifyProvider(firstProvider.id)
      return firstProvider
    } else {
      return provider
    }
  }

  // Have to put this as a getter to get it working with the debounce-method
  handleInputChange (e, fieldIndex) {
    const { fields } = this.wizardIdentifyProvider
    const fieldConfig: any = fields[fieldIndex]
    return this.$props.handleInputValue(e, fieldConfig, fieldIndex)
  }
}
